import CollapseTab from "@/components/CollapseTab";
import FilterSelect from "@/components/FilterSelect";
import PinList from "@/components/PinList";
import { SORT_ITEM_MAP, SORT_LIST } from "@/constants/sort";
import { getTopicPins } from "@/services";
import filterUrlParams from "@/utils/filterUrlParams";
import { safeParse } from "@/utils/safeParse";
import { useMemoizedFn } from "ahooks";
import { useRouter } from "next/router";
import QueryString from "qs";
import { useEffect, useMemo, useRef, useState } from "react";
import styles from "./index.module.less";
export default function CalendarsPinList(props) {
  const {
    calendarsList,
    festival,
    materialFilters,
    serverResult,
    showDownload,
  } = props;

  const [dataSource, setDataSource] = useState(serverResult || []);
  const [hasMore, setHasMore] = useState(true);
  const pageRef = useRef(serverResult ? 2 : 1);

  const router = useRouter();
  const currentFestival = useMemo(() => {
    return calendarsList.find((item) => item.code === festival);
  }, [calendarsList, festival]);

  const { filter_ids = null, sort = "all" } = router.query as {
    sort: string;
    filter_ids: any;
  };

  const flatFiltersArr = useMemo(() => {
    return currentFestival?.filters;
  }, [currentFestival]);

  const filterIdsMap = useMemo(() => {
    const filterIdsMap = filter_ids
      ? filterUrlParams.decode(filter_ids as string)
      : {};
    if (!filterIdsMap.festival) {
      filterIdsMap.festival = flatFiltersArr?.[0]?.id.toString();
    }
    return filterIdsMap;
  }, [filter_ids, flatFiltersArr]);

  const filters = useMemo(() => {
    return [
      {
        name: "综合排序",
        options: SORT_LIST,
        value: SORT_ITEM_MAP[sort],
        key: "sort",
        allowClear: false,
        isFilter: false,
      },
      materialFilters.find((item) => item.key === "source"),
      ...materialFilters.filter((item) => item.key !== "source"),
    ];
  }, [sort, materialFilters]);

  const getQuery = useMemoizedFn((data, key, isFilter) => {
    const query = {
      ...(filter_ids ? { filter_ids } : null),
      sort,
      festival,
    };
    // 需要拷贝一份数据，不能直接赋值
    let filterIdsMapCopy = safeParse(JSON.stringify(filterIdsMap));
    if (isFilter) {
      if (data?.value) {
        filterIdsMapCopy[key] = data?.value;
      } else {
        delete filterIdsMapCopy[key];
      }
      if (Object.keys(filterIdsMapCopy).length > 0) {
        query.filter_ids = filterUrlParams.encode(filterIdsMapCopy);
      } else {
        delete query.filter_ids;
      }
    } else if (data?.value) {
      query[key] = data.value;
    } else {
      delete query[key];
    }

    return query;
  });

  const filterChange = (data, key, isFilter) => {
    const query = getQuery(data, key, isFilter);
    // 添加shallow，可以避免切换筛选项时候重新执行服务端方法
    router.push(
      {
        query: query,
      },
      undefined,
      {
        shallow: true,
      }
    );
  };
  const activeIndex = useMemo(() => {
    let activeIndex = 0;
    flatFiltersArr?.forEach((item, index) => {
      if (filterIdsMap.festival === item.id.toString()) {
        activeIndex = index;
      }
    });
    return activeIndex;
  }, [filterIdsMap, flatFiltersArr]);

  const initRef = useRef(!serverResult);

  const queryAction = useMemo(() => {
    if (initRef.current) {
      pageRef.current = 1;
      setHasMore(true);
      setDataSource([]);
    }
    // aigcCategoryRef.current = filterIdsMap;
    return async () => {
      initRef.current = true;

      const filter_ids = filterIdsMap
        ? Object.values(filterIdsMap).reduce((result, value) => {
            result.push(value);
            return result;
          }, [])
        : [];

      const result = await getTopicPins({
        ...(sort ? { sort } : null),
        filter_ids: [...filter_ids],
        page: pageRef.current,
        per_page: 20,
        text: "",
        position: "topics",
      });
      const pins = result?.pins || [];
      if (pins.length <= 0) {
        setHasMore(false);
      }

      setDataSource((dataSource) => dataSource.concat(pins));
    };
  }, [sort, filterIdsMap]) as any;

  useEffect(() => {
    queryAction();
  }, [queryAction]);

  const onLoadMore = () => {
    if (initRef.current && dataSource.length > 0) {
      pageRef.current += 1;
      queryAction();
    }
  };
  const list = useMemo(() => {
    return flatFiltersArr?.map((item, index) => {
      const { id, name, img } = item;

      return {
        id,
        name,
        img,
        active: index === activeIndex,
        props: {
          "data-gd-click": "button_click",
          "data-button-name": `筛选项-${name}`,
          id: index === activeIndex ? "active-filter-two" : null,
          href:
            `?` +
            QueryString.stringify(
              getQuery({ value: item.id.toString() }, "festival", true)
            ),
        },
      };
    });
  }, [flatFiltersArr, activeIndex, getQuery]);

  return (
    <div>
      <div className="golbalHiddenH1">
        <h1>{currentFestival?.title}</h1>
      </div>
      <div className={styles.content}>
        <CollapseTab
          list={list}
          displayRow={3}
          maxHeight={174}
          itemClick={(item, e) => {
            e.preventDefault();
            filterChange({ value: item.id.toString() }, "festival", true);
          }}
        ></CollapseTab>
        <div className={styles.right}>
          {filters.map((item) => {
            let value;
            if (item.isFilter) {
              value =
                item?.options?.find(
                  (option) => filterIdsMap[item?.key] === option?.value
                ) || undefined;
            } else {
              value = item.value;
            }
            return (
              <FilterSelect
                key={item.key}
                className={styles.filter}
                {...item}
                value={value}
                onChange={(value) => {
                  filterChange(value, item.key, item.isFilter);
                }}
              ></FilterSelect>
            );
          })}
        </div>
      </div>
      <div className={styles.pinList}>
        <PinList
          dataSource={dataSource}
          hasMore={hasMore}
          showDownload={showDownload}
          onLoadMore={onLoadMore}
        ></PinList>
      </div>
    </div>
  );
}
